import log from 'loglevel';

function getPositiveExpiresIn(expiresIn: unknown): string | null {
  if (
    typeof expiresIn !== 'number' ||
    !Number.isFinite(expiresIn) ||
    expiresIn <= 0
  ) {
    return null;
  }

  return String(Math.floor(expiresIn));
}

export function buildDesktopSigninUrl({
  protocol,
  token,
  username,
  tenantId,
  expiresIn,
}: {
  protocol: string;
  token: string;
  username: string;
  tenantId: string;
  expiresIn: unknown;
}) {
  const queryParams = new URLSearchParams({
    token,
    username,
    tenantId,
  });
  const positiveExpiresIn = getPositiveExpiresIn(expiresIn);

  if (positiveExpiresIn) {
    queryParams.set('expiresIn', positiveExpiresIn);
  } else if (expiresIn !== undefined && expiresIn !== null) {
    // expires_in was provided but unusable (e.g. "3600" as string, 0,
    // NaN). Surface this so a future Access regression does not silently
    // drop Desktop back to the legacy 11-month expiration fallback.
    log.warn(
      'Access /tokens returned unusable expires_in; Desktop will use legacy expiration fallback',
      { received: expiresIn }
    );
  }

  return `${protocol}signin?${queryParams.toString()}`;
}
